import { useFilters } from '../context/FilterContext';

export function FilterBar() {
  const { filters, clearFilters } = useFilters();
  if (!filters.policyAreaId && !filters.variableId) return null;

  return (
    <div className="filter-bar">
      <span className="filter-label">Active filters:</span>
      {filters.policyAreaId && (
        <span className="filter-chip">Area: {filters.policyAreaId}</span>
      )}
      {filters.variableId && (
        <span className="filter-chip">Variable: {filters.variableId}</span>
      )}
      <button className="btn secondary" type="button" onClick={clearFilters} style={{ padding: '0.25rem 0.6rem', fontSize: '0.75rem' }}>
        Clear
      </button>
    </div>
  );
}
